module.exports = __webpack_public_path__ + "img/s04-bg1.d0f0585b.jpg";